<template>
  <div class="slot-display">
    <div v-if="currentSlot" class="slot-current">
      <div>
        Current slot
        {{ formatTime(currentSlot.start) }} - {{ formatTime(currentSlot.end) }}
      </div>
    </div>

    <div v-else class="slot-none">
      <p>No active slot right now.</p>
    </div>

    <div class="slot-countdown-holder">
      <CountdownTimer
        :deadline="nextSlot.start.getTime()"
        format="countdown"
        size="small"
      />
    </div>

    <div v-if="nextSlot" class="slot-next">
      Next slot
      {{ formatTime(nextSlot.start) }} - {{ formatTime(nextSlot.end) }}
    </div>
  </div>
</template>

<script setup>
import {
  ref, computed, onMounted, onBeforeUnmount,
} from 'vue';
import CountdownTimer from '~/Components/Frontend/CountdownTimer.vue';

const props = defineProps({
  slots: {
    type: Array,
    required: true,
  },
});

const locale = document.querySelector('meta[name="locale-code"]')?.content.replace('_', '-') || 'en';

const now = ref(new Date());
let timer = null;

onMounted(() => {
  timer = setInterval(() => {
    now.value = new Date();
  }, 1000);
});

onBeforeUnmount(() => {
  clearInterval(timer);
});

const parsedSlots = computed(() => props.slots.map((slot) => ({
  ...slot,
  start: new Date(slot.start),
  end: new Date(slot.end),
})));

const currentSlot = computed(() => parsedSlots.value.find((slot) => now.value >= slot.start && now.value < slot.end));

const nextSlot = computed(() => parsedSlots.value.find((slot) => now.value < slot.start));

const formatTime = (date) => date.toLocaleTimeString(locale, {
  hour: '2-digit',
  minute: '2-digit',
});
</script>

<style scoped>
.slot-display {
  text-align: center;
  display: grid;
  grid-template-columns: 1fr;
  gap: var(--sizing-4);
}
.slot-countdown-holder {
  width: fit-content;
  margin: 0 auto;
}
</style>
